// @ts-nocheck
import { useEffect, useCallback } from 'react';
import useUploadNotificationsSingle from './useUploadNotificationsSingle';
import { useAppDispatch } from '../hooks';
import { addToGroup } from '../middleware/signalRMiddleware';

const useUploadNotificationsGeneric = (
  tableData,
  setTableData,
  groupPrefix,
  importTransactions,
  idColumnName,
  isInProgressCallback
) => {
  const dispatch = useAppDispatch();

  const found = useCallback(
    (filteredTransactions) => {
      setTableData((prevState) =>
        prevState?.data
          ? {
              ...prevState,
              data: prevState.data.map((row) => {
                const importTransaction = filteredTransactions.find(
                  (i) => i.id === row[idColumnName]
                );
                return importTransaction
                  ? { ...row, ...importTransaction }
                  : row;
              }),
            }
          : prevState
      );
    },
    [setTableData, idColumnName]
  );
  const [uploadsInProgress, setUploadsInProgress] =
    useUploadNotificationsSingle(groupPrefix, importTransactions, found);
  useEffect(() => {
    if (tableData) {
      for (const i in tableData.data) {
        const row = tableData.data[i];
        if (
          isInProgressCallback(row) &&
          !uploadsInProgress.includes(row[idColumnName])
        ) {
          dispatch(addToGroup(`${groupPrefix}:${row[idColumnName]}`));
          setUploadsInProgress((prevState) =>
            prevState.includes(row[idColumnName])
              ? prevState
              : [...prevState, row[idColumnName]]
          );
        }
      }
    }
  }, [
    tableData,
    groupPrefix,
    idColumnName,
    isInProgressCallback,
    uploadsInProgress,
    setUploadsInProgress,
    dispatch,
  ]);
};
export default useUploadNotificationsGeneric;
